import { TRAFFIC_TYPES, useTrafficVisitTrend } from '@/api/common';
import { type DashboardWidgetComponentProps } from '@/components/Dashboard/types';
import VisitBreakdownTrendChart from '@/features/charts/VisitBreakdownTrendChart';
import { ROUTES } from '@/router';

const WebTrafficVisitByTypeTrendWidget = ({ pageFilters }: DashboardWidgetComponentProps) => {
  const { startDate, endDate, audience } = pageFilters;
  const {
    trafficTrendData: data,
    isLoading,
    error,
  } = useTrafficVisitTrend(startDate, endDate, { audienceId: audience?.id });

  return (
    <VisitBreakdownTrendChart
      data={data}
      isLoading={isLoading}
      error={error}
      tooltipRowLink={(point) => {
        const seriesId = point?.series?.userOptions?.id;
        if (seriesId === TRAFFIC_TYPES.TARGET) {
          return ROUTES.webTrafficActivityWithParams({
            'w.audienceIds': audience?.isTAM ? undefined : audience?.id,
            'w.inTam': audience?.isTAM ? 'true' : undefined,
            'w.metrics.visits': '[1,]',
          });
        } else if (seriesId === TRAFFIC_TYPES.OTHER) {
          return ROUTES.webTrafficActivityWithParams({
            'w.audienceIds!': audience?.isTAM ? undefined : audience?.id,
            'w.inTam': audience?.isTAM ? 'false' : undefined,
            'w.metrics.visits': '[1,]',
          });
        } else if (point?.key === 'total') {
          return ROUTES.webTrafficActivityWithParams({
            'w.metrics.visits': '[1,]',
          });
        }
      }}
    />
  );
};

export default WebTrafficVisitByTypeTrendWidget;
